<template>
    <div id="app">
        <router-view></router-view>

        <!-- 原生拖拽客服按钮 -->
        <div v-if="showServiceChat" class="floating-container">
            <div
                class="draggable-box"
                :style="{
                    left: `${x}px`,
                    top: `${y}px`,
                    width: `${boxWidth}px`,
                    height: `${boxHeight}px`,
                }"
                @mousedown="startDrag"
                @mouseup="handleMouseUp"
                @mouseleave="stopDrag"
                @mousemove="handleDrag"
            >
                <div class="Robot">
                    <el-tooltip ref="customerTooltip" content="在线客服" placement="top" effect="light" :disabled="isDragging">
                        <img
                            style="height: 60px; width: auto"
                            class="customer-service"
                            src="@/assets/hand.gif"
                            alt="在线客服"
                            :draggable="false"
                        />
                    </el-tooltip>
                </div>
            </div>
        </div>

        <im-chat v-show="$store.state.chat.chatShow" />
    </div>
</template>

<script>
import imChat from '@/components/chat/index.vue'
import talentApi from '@/api/talent'

export default {
    name: 'App',
    components: { imChat },
    data() {
        return {
            x: 100,
            y: 100,
            boxWidth: 79,
            boxHeight: 60,
            isDragging: false,
            startX: 0, // 鼠标按下时的X坐标
            startY: 0, // 鼠标按下时的Y坐标
            initialX: 0, // 元素初始X位置
            initialY: 0, // 元素初始Y位置
            moveDistance: 0, // 鼠标移动的距离（用于区分点击和拖拽）
            isWechat: false,
            showServiceChat: true,
        }
    },
    watch: {
        $route: {
            handler(val) {
                if (!val) return
                const notService = ['activityDetail', 'activity']
                this.showServiceChat = !notService.includes(val.name)
            },
            immediate: true,
        },
    },
    created() {
        // 初始化位置（靠右显示）
        this.x = window.innerWidth - 100
        this.y = window.innerHeight - 200
    },
    methods: {
        // 开始拖拽（鼠标按下）
        startDrag(e) {
            // 只响应左键
            if (e.button !== 0) return

            this.isDragging = true
            // 记录初始状态
            this.startX = e.clientX
            this.startY = e.clientY
            this.initialX = this.x
            this.initialY = this.y
            this.moveDistance = 0 // 重置移动距离

            // 隐藏tooltip
            this.$refs.customerTooltip?.hide()
            e.preventDefault()
        },

        // 处理拖拽（鼠标移动）
        handleDrag(e) {
            if (!this.isDragging) return

            // 计算移动距离（勾股定理，判断是否有实际移动）
            const deltaX = e.clientX - this.startX
            const deltaY = e.clientY - this.startY
            this.moveDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY)

            // 只有移动距离超过2px才认为是拖拽（避免轻微抖动误判）
            if (this.moveDistance > 2) {
                // 计算新位置并限制在窗口内
                const maxX = window.innerWidth - this.boxWidth
                const maxY = window.innerHeight - this.boxHeight
                this.x = Math.max(0, Math.min(this.initialX + deltaX, maxX))
                this.y = Math.max(0, Math.min(this.initialY + deltaY, maxY))
            }
        },

        // 鼠标抬起（统一处理结束逻辑）
        handleMouseUp() {
            // 先停止拖拽状态
            const wasDragging = this.isDragging
            this.isDragging = false

            // 只有当移动距离小于等于2px（视为纯点击）时，才打开客服
            if (wasDragging && this.moveDistance <= 2) {
                this.$store.dispatch('chat/chatModalToggle')
            }
        },

        // 鼠标离开元素（强制结束拖拽）
        stopDrag() {
            this.isDragging = false
        },

        checkWechatBrowser() {
            if (localStorage.getItem('activity-invite-code')) return
            const userAgent = navigator.userAgent.toLowerCase()
            this.isWechat = userAgent.includes('micromessenger')
            if (this.isWechat) {
                talentApi.openWechat().then((res) => {
                    window.open(res.data.redirect_url)
                })
            }
        },
    },
}
</script>

<style lang="scss">
/* 保持原有样式，优化光标显示 */
#app {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: #f0f5fa;
}

.Robot {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        cursor: pointer; /* 正常状态显示点击光标 */
        margin: 0;
    }
}

/* 拖拽时切换光标（通过动态class实现） */
.draggable-box {
    position: absolute;
    z-index: 99;
    pointer-events: auto;
    border: none;
    user-select: none;
    -webkit-user-select: none;

    &.is-dragging img {
        cursor: move; /* 拖拽时显示移动光标 */
    }
}

.floating-container {
    position: fixed;
    pointer-events: none;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
